/**
 * Register Page
 * Standalone registration page with navigation to dashboard on success
 * 
 * Requirements: 1.1, 1.5
 */

import { useNavigate } from 'react-router-dom';
import RegisterForm from '../components/auth/RegisterForm';

const Register = () => {
  const navigate = useNavigate();

  const handleRegisterSuccess = () => {
    // Requirement: 1.5 - Redirect to dashboard after successful registration
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#EAF4FB] to-white flex items-center justify-center px-4 py-8">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-[#17386E] mb-2">Inscription</h1>
            <p className="text-gray-600">Créez votre compte MyEduCycle</p>
          </div>
          
          <RegisterForm onSuccess={handleRegisterSuccess} />
          
          <div className="mt-6 text-center">
            <p className="text-sm text-gray-600">
              Vous avez déjà un compte?{' '}
              <a href="/login" className="text-[#17386E] hover:text-[#4CE0C2] font-semibold">
                Se connecter
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
